export const Renewal = 1;
export const NewBusiness = 2;